<template>
  <FilterLabel
    v-for="option in fieldConfig.optionList"
    :key="option.id"
    :label="option.label"
    :is-selected="values?.includes(option.value)"
    :with-check-icon="true"
    :disabled="disabled"
    @set-filter-value="$emit('update:values', option.value)"
  />
</template>

<script>
import FilterLabel from '~/components/filters/FilterLabel.vue';

export default {
  components: { FilterLabel },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    filtersConfig: {
      type: Array,
      default: () => [],
      required: true,
    },
    fieldConfig: {
      type: Object,
      default: () => {},
      required: true,
    },
    values: {
      type: Array,
      default: () => [],
      required: true,
    },
  },
  emits: ['update:values'],
};
</script>
